import { createSelector } from 'reselect';
import { MOBILE_VIDEO_CODE, MOBILE_VIDEO_STATUS } from '../../config/consts';

export const getPurchasePaymentResult = (state) => state.subscription.purchasePaymentResult;

export const getCodeVerificationError = (state) => {
  const { error } = state.subscription.videoMobileCode;

  return {
    data: error?.data || {},
    status: error?.status || null,
  };
};

export const getIsCodeVerificationLoading = (state) => state.subscription.videoMobileCode.isFetching;

const getIsMobileVideoSubscribed = (state) => state.sites?.dashboard?.data?.services?.MOBILE_VIDEO?.subscribed;

export const getMobileVideoLicense = (state) =>
  state.sites?.dashboard?.data?.services?.MOBILE_VIDEO?.licenceModel || {};

const getIsCodeExpirationState = createSelector(
  getMobileVideoLicense,
  (mobileVideoLicense) =>
    mobileVideoLicense?.status === MOBILE_VIDEO_STATUS.STANDARD ||
    mobileVideoLicense?.status === MOBILE_VIDEO_STATUS.STANDARD_RENEWAL ||
    (mobileVideoLicense?.licencesPool > 0 &&
      (mobileVideoLicense?.status === MOBILE_VIDEO_STATUS.TEMPORARY ||
        mobileVideoLicense?.status === MOBILE_VIDEO_STATUS.STANDARD_EXPIRED))
);

export const getCodeExpirationState = createSelector(
  getIsMobileVideoSubscribed,
  getMobileVideoLicense,
  getIsCodeExpirationState,
  (subscribed, mobileVideoLicense, isExpirationState) => {
    if (isExpirationState) {
      if (subscribed && mobileVideoLicense?.nextPayment) {
        return MOBILE_VIDEO_CODE.EXPIRATION.NEXT_PAYMENT;
      }

      if (!subscribed && mobileVideoLicense.poolExpiration) {
        return MOBILE_VIDEO_CODE.EXPIRATION.POOL_EXPIRATION;
      }

      if (!subscribed && !mobileVideoLicense.poolExpiration) {
        return MOBILE_VIDEO_CODE.EXPIRATION.VALIDITY;
      }
    }

    return '';
  }
);

export const getCodeCreditState = createSelector(getMobileVideoLicense, (mobileVideoLicense) => {
  const states = [];
  if (
    mobileVideoLicense?.licencesPool === 0 &&
    [
      MOBILE_VIDEO_STATUS.TRIAL_ACTIVE,
      MOBILE_VIDEO_STATUS.TRIAL_EXPIRED,
      MOBILE_VIDEO_STATUS.TEMPORARY,
      MOBILE_VIDEO_STATUS.STANDARD_EXPIRED,
    ].includes(mobileVideoLicense?.status)
  ) {
    states.push(MOBILE_VIDEO_CODE.CREDIT.EMPTY);
  }

  if (
    [MOBILE_VIDEO_STATUS.STANDARD, MOBILE_VIDEO_STATUS.STANDARD_RENEWAL].includes(mobileVideoLicense?.status) ||
    (mobileVideoLicense?.licencesPool > 0 &&
      [MOBILE_VIDEO_STATUS.TEMPORARY, MOBILE_VIDEO_STATUS.STANDARD_EXPIRED].includes(mobileVideoLicense?.status))
  ) {
    states.push(MOBILE_VIDEO_CODE.CREDIT.REMAINING);
  }

  if (mobileVideoLicense?.licencesPool > 0) {
    states.push(MOBILE_VIDEO_CODE.CREDIT.POOL);
  }

  return states;
});

export const getCodeData = (state) => state.subscription.videoMobileCode.data;

export const getVerifiedCode = (state) => state.subscription.videoMobileCode.code;

export const getCodeActivationError = (state) => state.subscription.videoMobileCode.activation.error;

export const getIsCodeActivationLoading = (state) => state.subscription.videoMobileCode.activation.isFetching;

export const getIsVatVerified = (state) => state.subscription.vatVerification.isVerified;

export const getIsVatVerifiedFetching = (state) => state.subscription.vatVerification.isFetching;
